import { render } from "./MarketCard.vue?vue&type=template&id=3ca59286&scoped=true"
import script from "./MarketCard.vue?vue&type=script&lang=js"
export * from "./MarketCard.vue?vue&type=script&lang=js"

import "./MarketCard.vue?vue&type=style&index=0&id=3ca59286&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca59286"]])

export default __exports__